export enum ConnectActivityCategory {
    COACHING = 'COACHING',
    MENTORING = 'MENTORING'
}
